// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationBlock_pagination__veeKO","paginationItem":"PaginationBlock_paginationItem__0wsdZ","active":"PaginationBlock_active__PvOuz"};